import React, { memo } from 'react'
import { TableRow } from 'transfix-ui/components/Table'
import { useFeatureFlag } from 'utils/context/FeatureFlagsContext'
import { LaneAlert } from 'apps/marketplace/apiTypes/carrierLaneAlerts'
import {
  SavedLanesTableLanePreferenceCell,
  SavedLanesTableMinTotalRateCell,
  SavedLanesTablePickupAvailabilityCell,
  SavedLanesTableRecipientCell,
  SavedLanesTableAddedByCell,
  SavedLanesTableOptionsCell,
} from './SavedLanesTableCells'

interface ISavedLanesTableRowProps {
  savedLane: LaneAlert
  onDelete: (savedLane: LaneAlert) => void
  onEdit: (savedLane: LaneAlert) => void
}

export const SavedLanesTableRow = memo(
  ({ onDelete, onEdit, savedLane }: ISavedLanesTableRowProps) => {
    const refactoredSavedLanesCreateAndUpdateEnabled = useFeatureFlag(
      'refactoredSavedLanesCreateAndUpdate'
    )

    return (
      <TableRow dataTest='saved-lane-row'>
        <SavedLanesTableLanePreferenceCell {...savedLane} />
        <SavedLanesTableMinTotalRateCell {...savedLane} />
        <SavedLanesTablePickupAvailabilityCell {...savedLane} />
        <SavedLanesTableRecipientCell {...savedLane} />
        {!refactoredSavedLanesCreateAndUpdateEnabled && (
          <SavedLanesTableAddedByCell {...savedLane} />
        )}
        <SavedLanesTableOptionsCell savedLane={savedLane} onDelete={onDelete} onEdit={onEdit} />
      </TableRow>
    )
  }
)
